// Helper to get current date formatted
const getTodayFormatted = () => {
  const today = new Date();
  return today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const getDateOffset = (daysAgo: number) => {
  const date = new Date();
  date.setDate(date.getDate() + daysAgo);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const dealCategories = [
  { id: 'all', name: 'All Deals', icon: 'ri-price-tag-3-line' },
  { id: 'restaurant', name: 'Dining', icon: 'ri-restaurant-line' },
  { id: 'retail', name: 'Shopping', icon: 'ri-shopping-bag-line' },
  { id: 'health', name: 'Health & Beauty', icon: 'ri-heart-pulse-line' },
  { id: 'home', name: 'Home Services', icon: 'ri-home-gear-line' },
  { id: 'auto', name: 'Automotive', icon: 'ri-car-line' },
  { id: 'entertainment', name: 'Entertainment', icon: 'ri-movie-2-line' },
  { id: 'fitness', name: 'Fitness', icon: 'ri-run-line' },
];

export const localDeals = [
  {
    id: 1,
    businessName: 'Roseville Family Dental',
    businessLogo: 'ri-tooth-line',
    category: 'health',
    dealTitle: '20% Off Your First Visit',
    description:
      'New patients receive 20% off any dental service including cleanings, exams, and cosmetic consultations. Includes free X-rays with comprehensive exam.',
    originalPrice: 250,
    dealPrice: 200,
    discountPercent: 20,
    image:
      'https://public.readdy.ai/ai/img_res/e4c5fc7a24633a47e2c5f7e05a635cfb.jpg',
    address: '1234 Douglas Blvd, Roseville, CA 95678',
    phone: '(916) 555-0142',
    website: 'www.rosevillefamilydental.com',
    rating: 4.9,
    reviews: 312,
    expiresAt: getDateOffset(122),
    claimed: 87,
    featured: true,
    couponCode: 'NEWSMILE20',
    hours: 'Mon–Fri: 8am–5pm | Sat: 9am–2pm | Sun: Closed',
    terms: [
      'Valid for new patients only.',
      'Cannot be combined with insurance benefits or other offers.',
      'Must present coupon code at time of booking.',
      'Applies to cleanings, exams, and cosmetic consultations only.',
      'One coupon per patient per visit.',
      `Offer expires ${getDateOffset(122)}.`,
    ],
    mapQuery: 'Roseville+Family+Dental+1234+Douglas+Blvd+Roseville+CA',
  },
  {
    id: 2,
    businessName: 'Roseville Pizza Kitchen',
    businessLogo: 'ri-restaurant-2-line',
    category: 'restaurant',
    dealTitle: 'Buy One Get One Free Pizza',
    description:
      'Order any large wood-fired pizza and get a second pizza of equal or lesser value absolutely free. Dine-in or takeout. Valid Monday through Thursday.',
    originalPrice: 36,
    dealPrice: 18,
    discountPercent: 50,
    image:
      'https://readdy.ai/api/search-image?query=delicious%20artisan%20wood%20fired%20pizza%20with%20fresh%20toppings%20melted%20mozzarella%20cheese%20basil%20leaves%20on%20rustic%20wooden%20board%20warm%20restaurant%20ambiance%20Italian%20cuisine%20food%20photography&width=600&height=400&seq=deal2&orientation=landscape',
    address: '780 Pleasant Grove Blvd, Roseville, CA 95678',
    phone: '(916) 555-0411',
    website: 'www.rosevillepizzakitchen.com',
    rating: 4.6,
    reviews: 428,
    expiresAt: getDateOffset(137),
    claimed: 214,
    featured: true,
    couponCode: 'BOGOPIZZA',
    hours: 'Mon–Thu: 11am–9pm | Fri–Sat: 11am–10pm | Sun: 12pm–8pm',
    terms: [
      'Buy one large pizza, get one of equal or lesser value free.',
      'Valid Monday through Thursday only.',
      'Dine-in or takeout; not valid for delivery.',
      'Cannot be combined with other promotions or discounts.',
      'One coupon per table per visit.',
      `Offer expires ${getDateOffset(137)}.`,
    ],
    mapQuery: 'Roseville+Pizza+Kitchen+780+Pleasant+Grove+Blvd+Roseville+CA',
  },
  {
    id: 3,
    businessName: 'Sierra Auto Works',
    businessLogo: 'ri-car-washing-line',
    category: 'auto',
    dealTitle: 'Free Brake Inspection + 15% Off Repairs',
    description:
      'Complimentary multi-point brake inspection for all vehicles. If repairs are needed, enjoy 15% off parts and labor. ASE-certified technicians you can trust.',
    originalPrice: 120,
    dealPrice: 0,
    discountPercent: 100,
    image:
      'https://readdy.ai/api/search-image?query=professional%20auto%20mechanic%20inspecting%20car%20brakes%20in%20clean%20modern%20garage%20well%20lit%20automotive%20repair%20shop%20with%20organized%20tools%20and%20equipment%20professional%20service%20center&width=600&height=400&seq=deal3&orientation=landscape',
    address: '890 Riverside Ave, Roseville, CA 95678',
    phone: '(916) 555-0198',
    website: 'www.sierraautoworks.com',
    rating: 4.8,
    reviews: 187,
    expiresAt: getDateOffset(153),
    claimed: 63,
    featured: true,
    couponCode: 'FREEBRAKE',
    hours: 'Mon–Fri: 7:30am–6pm | Sat: 8am–3pm | Sun: Closed',
    terms: [
      'Free brake inspection for all vehicle makes and models.',
      '15% discount applies to brake repair parts and labor only.',
      'Must mention coupon code when scheduling appointment.',
      'Cannot be combined with other service specials.',
      'One coupon per vehicle.',
      `Offer expires ${getDateOffset(153)}.`,
    ],
    mapQuery: 'Sierra+Auto+Works+890+Riverside+Ave+Roseville+CA',
  },
  {
    id: 4,
    businessName: 'Bloom & Vine Florist',
    businessLogo: 'ri-plant-line',
    category: 'retail',
    dealTitle: '15% Off Wedding Flower Packages',
    description:
      'Book your wedding florals with us and save 15% on complete packages including bridal bouquet, centerpieces, ceremony arch, and boutonnieres. Free consultation included.',
    originalPrice: 2000,
    dealPrice: 1700,
    discountPercent: 15,
    image:
      'https://readdy.ai/api/search-image?query=stunning%20wedding%20flower%20arrangement%20with%20white%20roses%20peonies%20and%20eucalyptus%20on%20elegant%20table%20setting%20romantic%20floral%20centerpiece%20bridal%20bouquet%20professional%20florist%20work%20soft%20natural%20lighting&width=600&height=400&seq=deal4&orientation=landscape',
    address: '456 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-0267',
    website: 'www.bloomandvineflorist.com',
    rating: 4.9,
    reviews: 156,
    expiresAt: getDateOffset(184),
    claimed: 29,
    featured: false,
    couponCode: 'WEDDING15',
    hours: 'Mon–Fri: 9am–6pm | Sat: 10am–4pm | Sun: Closed',
    terms: [
      'Applies to complete wedding flower packages only.',
      'Free consultation must be booked in advance.',
      'Deposit required at time of booking.',
      'Cannot be combined with seasonal promotions.',
      'Minimum order of $1,000 required.',
      `Offer expires ${getDateOffset(184)}.`,
    ],
    mapQuery: 'Bloom+Vine+Florist+456+Vernon+St+Roseville+CA',
  },
  {
    id: 5,
    businessName: 'Placer Fitness Studio',
    businessLogo: 'ri-run-line',
    category: 'fitness',
    dealTitle: 'First Month Unlimited Classes $29',
    description:
      'Try unlimited yoga, pilates, HIIT, and spin classes for your entire first month at just $29. No commitment required. Includes a free fitness assessment.',
    originalPrice: 89,
    dealPrice: 29,
    discountPercent: 67,
    image:
      'https://readdy.ai/api/search-image?query=energetic%20group%20fitness%20class%20in%20modern%20boutique%20studio%20with%20participants%20doing%20yoga%20stretches%20bright%20natural%20light%20wooden%20floors%20large%20mirrors%20motivating%20atmosphere%20healthy%20lifestyle&width=600&height=400&seq=deal5&orientation=landscape',
    address: '2100 Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 555-0334',
    website: 'www.placerfitnessstudio.com',
    rating: 4.7,
    reviews: 243,
    expiresAt: getDateOffset(142),
    claimed: 156,
    featured: false,
    couponCode: 'FIT29',
    hours: 'Mon–Fri: 5am–9pm | Sat–Sun: 7am–5pm',
    terms: [
      'Valid for first-time members only.',
      'Unlimited access to all group classes for 30 days.',
      'No long-term commitment required.',
      'Must present valid ID at sign-up.',
      'Cannot be combined with other membership offers.',
      `Offer expires ${getDateOffset(142)}.`,
    ],
    mapQuery: 'Placer+Fitness+Studio+2100+Sunrise+Ave+Roseville+CA',
  },
  {
    id: 6,
    businessName: 'Craft & Cork Wine Bar',
    businessLogo: 'ri-goblet-line',
    category: 'restaurant',
    dealTitle: 'Half-Price Wine Flights Every Tuesday',
    description:
      'Enjoy curated California wine flights at 50% off every Tuesday evening. Choose from our rotating selection of Napa, Sonoma, and Sierra Foothills wines paired with artisan cheese.',
    originalPrice: 28,
    dealPrice: 14,
    discountPercent: 50,
    image:
      'https://readdy.ai/api/search-image?query=elegant%20wine%20flight%20tasting%20with%20four%20glasses%20of%20red%20and%20white%20wine%20on%20wooden%20paddle%20board%20artisan%20cheese%20plate%20alongside%20warm%20ambient%20wine%20bar%20lighting%20sophisticated%20atmosphere&width=600&height=400&seq=deal6&orientation=landscape',
    address: '410 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-0856',
    website: 'www.craftandcorkbar.com',
    rating: 4.8,
    reviews: 176,
    expiresAt: 'Ongoing',
    claimed: 342,
    featured: false,
    couponCode: 'WINETUESDAY',
    hours: 'Tue–Thu: 4pm–10pm | Fri–Sat: 3pm–11pm | Sun: 3pm–8pm | Mon: Closed',
    terms: [
      'Valid on Tuesdays only.',
      'Applies to wine flights only; not valid on bottles or glasses.',
      'Must be 21 years or older with valid ID.',
      'Dine-in only.',
      'Cannot be combined with happy hour specials.',
      'Ongoing offer — no expiration.',
    ],
    mapQuery: 'Craft+Cork+Wine+Bar+410+Vernon+St+Roseville+CA',
  },
  {
    id: 7,
    businessName: 'Green Thumb Landscaping',
    businessLogo: 'ri-leaf-line',
    category: 'home',
    dealTitle: 'Free Landscape Design Consultation',
    description:
      'Get a complimentary on-site landscape design consultation valued at $150. Our experts will create a custom plan for your yard including drought-tolerant California native options.',
    originalPrice: 150,
    dealPrice: 0,
    discountPercent: 100,
    image:
      'https://readdy.ai/api/search-image?query=beautiful%20California%20drought%20tolerant%20garden%20design%20with%20native%20plants%20succulents%20decorative%20gravel%20stone%20pathway%20and%20modern%20outdoor%20lighting%20professional%20landscaping%20suburban%20home%20front%20yard&width=600&height=400&seq=deal7&orientation=landscape',
    address: '3200 Foothills Blvd, Roseville, CA 95747',
    phone: '(916) 555-0523',
    website: 'www.greenthumbroseville.com',
    rating: 4.8,
    reviews: 98,
    expiresAt: getDateOffset(153),
    claimed: 41,
    featured: false,
    couponCode: 'FREEDESIGN',
    hours: 'Mon–Fri: 8am–5pm | Sat: 9am–1pm | Sun: Closed',
    terms: [
      'Free consultation for residential properties only.',
      'Consultation includes on-site visit and basic design plan.',
      'Detailed blueprints and 3D renderings available at additional cost.',
      'Must schedule appointment in advance.',
      'Service area limited to Roseville and surrounding communities.',
      `Offer expires ${getDateOffset(153)}.`,
    ],
    mapQuery: 'Green+Thumb+Landscaping+3200+Foothills+Blvd+Roseville+CA',
  },
  {
    id: 8,
    businessName: 'Roseville Pet Paradise',
    businessLogo: 'ri-bear-smile-line',
    category: 'retail',
    dealTitle: '10% Off All Grooming Services',
    description:
      'Pamper your furry friend with 10% off any grooming package including bath, haircut, nail trim, and ear cleaning. All breeds welcome. Book online or walk in.',
    originalPrice: 65,
    dealPrice: 58,
    discountPercent: 10,
    image:
      'https://readdy.ai/api/search-image?query=adorable%20golden%20retriever%20getting%20professional%20grooming%20bath%20at%20pet%20salon%20clean%20bright%20pet%20grooming%20facility%20with%20professional%20groomer%20caring%20for%20happy%20dog%20warm%20friendly%20atmosphere&width=600&height=400&seq=deal8&orientation=landscape',
    address: '620 N Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 555-0789',
    website: 'www.rosevillepetparadise.com',
    rating: 4.7,
    reviews: 201,
    expiresAt: getDateOffset(122),
    claimed: 118,
    featured: false,
    couponCode: 'PETGROOM10',
    hours: 'Mon–Sat: 8am–6pm | Sun: 10am–4pm',
    terms: [
      'Valid for all grooming packages and services.',
      'All breeds and sizes welcome.',
      'Walk-ins accepted; appointments recommended.',
      'Cannot be combined with loyalty program discounts.',
      'One coupon per pet per visit.',
      `Offer expires ${getDateOffset(122)}.`,
    ],
    mapQuery: 'Roseville+Pet+Paradise+620+N+Sunrise+Ave+Roseville+CA',
  },
  {
    id: 9,
    businessName: 'Sunrise Spa & Wellness',
    businessLogo: 'ri-leaf-line',
    category: 'health',
    dealTitle: '$49 Introductory Massage (60 min)',
    description:
      'First-time clients enjoy a relaxing 60-minute Swedish or deep tissue massage for only $49 (regularly $95). Includes aromatherapy upgrade and hot towel treatment.',
    originalPrice: 95,
    dealPrice: 49,
    discountPercent: 48,
    image:
      'https://readdy.ai/api/search-image?query=serene%20spa%20treatment%20room%20with%20massage%20table%20white%20linens%20candles%20and%20orchid%20flowers%20calming%20zen%20atmosphere%20warm%20ambient%20lighting%20professional%20wellness%20center%20relaxation%20space&width=600&height=400&seq=deal9&orientation=landscape',
    address: '1800 Taylor Rd, Roseville, CA 95661',
    phone: '(916) 555-0945',
    website: 'www.sunrisespawellness.com',
    rating: 4.9,
    reviews: 189,
    expiresAt: getDateOffset(137),
    claimed: 203,
    featured: false,
    couponCode: 'RELAX49',
    hours: 'Mon–Sat: 9am–8pm | Sun: 10am–6pm',
    terms: [
      'Valid for first-time clients only.',
      'Choose Swedish or deep tissue massage.',
      'Includes complimentary aromatherapy and hot towel.',
      'Appointment required; subject to availability.',
      'Gratuity not included.',
      `Offer expires ${getDateOffset(137)}.`,
    ],
    mapQuery: 'Sunrise+Spa+Wellness+1800+Taylor+Rd+Roseville+CA',
  },
  {
    id: 10,
    businessName: 'Roseville Bowl & Fun Zone',
    businessLogo: 'ri-movie-2-line',
    category: 'entertainment',
    dealTitle: 'Family Fun Pack — $39.99',
    description:
      '2 hours of bowling for up to 4 people, shoe rentals included, plus a large pizza and pitcher of soda. Perfect for family night out. Available weekdays only.',
    originalPrice: 72,
    dealPrice: 39.99,
    discountPercent: 44,
    image:
      'https://readdy.ai/api/search-image?query=modern%20bowling%20alley%20with%20colorful%20neon%20lighting%20lanes%20with%20pins%20set%20up%20family%20entertainment%20center%20fun%20atmosphere%20with%20arcade%20games%20visible%20in%20background%20vibrant%20recreational%20facility&width=600&height=400&seq=deal10&orientation=landscape',
    address: '1095 Tinker Way, Roseville, CA 95678',
    phone: '(916) 555-1023',
    website: 'www.rosevillebowl.com',
    rating: 4.5,
    reviews: 334,
    expiresAt: getDateOffset(168),
    claimed: 178,
    featured: false,
    couponCode: 'FAMILYFUN',
    hours: 'Mon–Thu: 12pm–9pm | Fri: 12pm–11pm | Sat: 10am–11pm | Sun: 10am–8pm',
    terms: [
      'Includes 2 hours of bowling for up to 4 people.',
      'Shoe rentals included for all 4 guests.',
      'Includes one large cheese or pepperoni pizza and one pitcher of soda.',
      'Available Monday through Friday only.',
      'Must present coupon code at front desk.',
      `Offer expires ${getDateOffset(168)}.`,
    ],
    mapQuery: 'Roseville+Bowl+Fun+Zone+1095+Tinker+Way+Roseville+CA',
  },
  {
    id: 11,
    businessName: 'The Clean Machine',
    businessLogo: 'ri-home-gear-line',
    category: 'home',
    dealTitle: '25% Off Deep House Cleaning',
    description:
      'Professional deep cleaning service at 25% off for first-time customers. Includes kitchen, bathrooms, bedrooms, and living areas. Eco-friendly products used. Satisfaction guaranteed.',
    originalPrice: 200,
    dealPrice: 150,
    discountPercent: 25,
    image:
      'https://readdy.ai/api/search-image?query=sparkling%20clean%20modern%20kitchen%20interior%20after%20professional%20deep%20cleaning%20service%20white%20countertops%20gleaming%20stainless%20steel%20appliances%20organized%20bright%20natural%20light%20spotless%20home&width=600&height=400&seq=deal11&orientation=landscape',
    address: '500 Harding Blvd, Roseville, CA 95678',
    phone: '(916) 555-1156',
    website: 'www.thecleanmachineroseville.com',
    rating: 4.6,
    reviews: 87,
    expiresAt: getDateOffset(153),
    claimed: 54,
    featured: false,
    couponCode: 'CLEAN25',
    hours: 'Mon–Fri: 7am–6pm | Sat: 8am–4pm | Sun: Closed',
    terms: [
      'Valid for first-time customers only.',
      'Applies to deep cleaning service for homes up to 2,500 sq ft.',
      'Larger homes may incur additional charges.',
      'Eco-friendly, non-toxic products used.',
      'Must book at least 48 hours in advance.',
      `Offer expires ${getDateOffset(153)}.`,
    ],
    mapQuery: 'The+Clean+Machine+500+Harding+Blvd+Roseville+CA',
  },
  {
    id: 12,
    businessName: 'Sakura Sushi House',
    businessLogo: 'ri-restaurant-line',
    category: 'restaurant',
    dealTitle: 'All-You-Can-Eat Lunch $18.99',
    description:
      'Unlimited sushi, sashimi, and Japanese appetizers during lunch hours (11am-2pm). Over 50 items to choose from. Includes miso soup and edamame. Dine-in only.',
    originalPrice: 28,
    dealPrice: 18.99,
    discountPercent: 32,
    image:
      'https://readdy.ai/api/search-image?query=beautiful%20assorted%20sushi%20platter%20with%20fresh%20salmon%20tuna%20and%20shrimp%20nigiri%20colorful%20maki%20rolls%20on%20elegant%20black%20slate%20plate%20Japanese%20restaurant%20presentation%20with%20wasabi%20and%20ginger&width=600&height=400&seq=deal12&orientation=landscape',
    address: '1220 Galleria Blvd, Roseville, CA 95678',
    phone: '(916) 555-1289',
    website: 'www.sakurasushihouse.com',
    rating: 4.4,
    reviews: 267,
    expiresAt: 'Ongoing',
    claimed: 489,
    featured: false,
    couponCode: 'SUSHILUNCH',
    hours: 'Mon–Thu: 11am–9:30pm | Fri–Sat: 11am–10:30pm | Sun: 12pm–9pm',
    terms: [
      'All-you-can-eat available during lunch hours only (11am–2pm).',
      'Dine-in only; not valid for takeout or delivery.',
      'Includes sushi, sashimi, appetizers, miso soup, and edamame.',
      'Wasted food may incur additional charges.',
      'Cannot be combined with other promotions.',
      'Ongoing offer — no expiration.',
    ],
    mapQuery: 'Sakura+Sushi+House+1220+Galleria+Blvd+Roseville+CA',
  },
];